import React, { useState, useEffect } from 'react';
import defaultPlaceholderImage from 'assets/img/rambla-icon.png';
import styled from 'styled-components';

const ImageWithPlaceholder = ({ src, alt, placeholder, ...rest }) => {
  const [srcFailed, setSrcFailed] = useState(false);
  const [placeholderFailed, setPlaceholderFailed] = useState(false);

  useEffect(() => {
    setSrcFailed(false);
    setPlaceholderFailed(false);
  }, [src, placeholder]);

  let imageSrc;
  let isUsingDefault = false;

  if (src && !srcFailed) {
    imageSrc = src;
  } else if (placeholder && !placeholderFailed) {
    imageSrc = placeholder;
  } else {
    imageSrc = defaultPlaceholderImage;
    isUsingDefault = true;
  }

  const handleError = () => {
    if (imageSrc === src) {
      setSrcFailed(true);
    } else if (imageSrc === placeholder) {
      setPlaceholderFailed(true);
    }
  };

  return (
    <Image src={imageSrc} alt={alt} onError={handleError} $isDefault={isUsingDefault} {...rest} />
  );
};

const Image = styled.img`
  opacity: ${({ $isDefault }) => ($isDefault ? 0.3 : 1)};
`;

export default ImageWithPlaceholder;
